module.exports = __webpack_public_path__ + "img/neon.5e98062b.svg";